var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8998 5.94961V14.4496H3.0998V5.94961H9.8998ZM8.6248 0.849609H4.3748L3.5248 1.69961H0.549805V3.39961H12.4498V1.69961H9.4748L8.6248 0.849609ZM11.5998 4.24961H1.3998V14.4496C1.3998 15.3846 2.1648 16.1496 3.0998 16.1496H9.8998C10.8348 16.1496 11.5998 15.3846 11.5998 14.4496V4.24961Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a86d8b155ffe6faf7084f158ffff8dc3.svg";
export { ForwardRef as ReactComponent };